import React, { useState } from "react";
import { Link } from "react-router-dom";
import PopUp from "./PopUp";
import faqData from "./garbage/FooterData";

const Footer: React.FC = () => {
  const [isPopUpOpen, setPopUpOpen] = useState(false);
  const [popUpContent, setPopUpContent] = useState<{
    title: string;
    textComponent?: React.ReactNode; // Using ReactNode for components
  }>({
    title: "",
  });

  const handlePopUpOpen = (title: string, textComponent?: React.ReactNode) => {
    setPopUpContent({ title, textComponent });
    setPopUpOpen(true);
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-6 py-10 grid gap-8 md:grid-cols-4">
        {/* About */}
        <div>
          <h3 className="text-lg font-semibold text-white">About Us</h3>
          <p className="mt-4 text-sm">
            Your trusted store for quality products. We bring you the best deals
            and amazing offers.
          </p>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white">Quick Links</h3>
          <ul className="mt-4 space-y-2">
            <li>
              <Link to="/" className="hover:text-white">
                Home
              </Link>
            </li>
            <li>
              <Link to="/catalog" className="hover:text-white">
                Shop
              </Link>
            </li>
            <li>
              <button
                onClick={() =>
                  handlePopUpOpen("About Us", <p>{faqData.about}</p>)
                }
                className="hover:text-white"
              >
                About
              </button>
            </li>
            <li>
              <Link to="/support" className="hover:text-white">
                Contacts
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white">Customer Support</h3>
          <ul className="mt-4 space-y-2">
            <li>
              <button
                onClick={() =>
                  handlePopUpOpen(
                    "FAQs",
                    <div>
                      {faqData.faqs.map((faq, index) => (
                        <div key={index}>
                          <h3 className="text-lg font-medium">
                            {faq.question}
                          </h3>
                          <p>{faq.answer}</p>
                        </div>
                      ))}
                    </div>
                  )
                }
                className="hover:text-white"
              >
                FAQs
              </button>
            </li>
            <li>
              <button
                onClick={() =>
                  handlePopUpOpen(
                    "Shipping & Returns",
                    <p>{faqData.shippingAndReturns}</p>
                  )
                }
                className="hover:text-white"
              >
                Shipping & Returns
              </button>
            </li>
            <li>
              <button
                onClick={() =>
                  handlePopUpOpen(
                    "Terms of Service",
                    <p>{faqData.termsOfService}</p>
                  )
                }
                className="hover:text-white"
              >
                Terms of Service
              </button>
            </li>
            <li>
              <button
                onClick={() =>
                  handlePopUpOpen(
                    "Privacy Policy",
                    <p>{faqData.privacyPolicy}</p>
                  )
                }
                className="hover:text-white"
              >
                Privacy Policy
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white">Subscribe</h3>
          <p className="mt-4 text-sm">
            Join our newsletter for exclusive deals. To join our newsletter
            please reach our email storestore@info.com
          </p>
          {/* <form className="mt-4 flex">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-4 py-2 rounded-l bg-gray-800 text-gray-200 focus:outline-none"
            />
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-r"
            >
              Subscribe
            </button>
          </form> */}
        </div>
      </div>

      {isPopUpOpen && (
        <PopUp
          title={popUpContent.title}
          textComponent={popUpContent.textComponent}
          onClose={() => setPopUpOpen(false)}
        />
      )}

      <div className="border-t border-gray-700 text-center py-4 text-sm">
        &copy; {new Date().getFullYear()} Mobile+ Team 18. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
